import React, { useRef, useState } from 'react';
import {
 Container,
 Box,
 Typography,
 Grid,
 TextField,
 Button,
 CircularProgress,
} from '@mui/material';
import { auth } from '../services/api/auth';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const VerifyCodePage = () => {
 const inputRefs = useRef([]);
 const [code, setCode] = useState(Array(6).fill(''));
 const [phone, setPhone] = useState('');
 const [isVerifying, setIsVerifying] = useState(false);
 const navigate = useNavigate()

 const handleChange = (e, idx) => {
  const value = e.target.value;
  if (!/^\d*$/.test(value)) return;

  const newCode = [...code];
  newCode[idx] = value.slice(-1); // limit to 1 digit
  setCode(newCode);

  if (value && idx < 5) {
   inputRefs.current[idx + 1]?.focus();
  }
 };

 const handleKeyDown = (e, idx) => {
  if (e.key === 'Backspace' && !code[idx] && idx > 0) {
   inputRefs.current[idx - 1]?.focus();
  }
 };

 const handleSubmit = (e) => {
  setIsVerifying(true)
  e.preventDefault();
  const fullCode = code.join('');
  const formData = new FormData()
  formData.append('code', fullCode)
  formData.append('phone_number', phone)
  if (phone === '') return toast.warn('Please enter your phone number');
  if (fullCode.length < 6) return toast.warn('Please enter the 6-digit code');
  auth.verifySignUp(formData).then((res) => {
   if (res.status === 201) {
    toast.success(res.data?.message)
    navigate('/auth/login')
   }
  }).catch((err) => console.log(err)).finally(() => setIsVerifying(false))
 };

 return (
  <Container maxWidth="sm">
   <Box sx={{ mt: 6, textAlign: 'center' }}>
    <Typography variant="h5" gutterBottom>
     Verify Your Phone number
    </Typography>
    <Typography variant="body1" sx={{ mb: 3 }}>
     Enter the 6-digit code sent to your phone
    </Typography>

    <form onSubmit={handleSubmit}>
     <TextField
      name='phone'
      label='Phone Number'
      type='tel'
      value={phone}
      sx={{ margin: '10px 0' }}
      onChange={(e) => setPhone(e.target.value)}
     />
     <Grid container spacing={1} justifyContent="center">
      {code.map((digit, idx) => (
       <Grid item key={idx}>
        <TextField
         inputProps={{ maxLength: 1, style: { textAlign: 'center' } }}
         value={digit}
         onChange={(e) => handleChange(e, idx)}
         onKeyDown={(e) => handleKeyDown(e, idx)}
         inputRef={(el) => (inputRefs.current[idx] = el)}
         sx={{ width: 50 }}
        />
       </Grid>
      ))}
     </Grid>

     <Button
      type="submit"
      variant="contained"
      sx={{ mt: 3 }}
      fullWidth
      disabled={isVerifying === true}
     >
      {isVerifying ? <CircularProgress /> : 'Verify'}
     </Button>
    </form>
   </Box>
  </Container>
 );
};

export default VerifyCodePage;
